import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { useState } from "react";
import { CustomerDto, PaymentDto } from "./types";
import { renderClose, useDialog } from "../../common/dialog";
import { PaymentDialog } from "./PaymentDialog";
import { UserTypeId, useAccountStore } from "../../common/account";
import { Add } from "@mui/icons-material";
import { UseEntityStore } from "../../common/entityStore";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";

export function PaymentListDialog(props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
}) {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [usePaymentListStore] = useState(() => createListStore<PaymentDto>({
        path: "customers/payments?customerId=" + customer.id, listProps: [
            { column: "invcId", label: "Invoice number", width: 120 },
            { column: "payDte", label: "Payment date", width: 120, type: "date" },
            { column: "payAmt", label: "Payment amount", width: 120, type: "currency" },
            { column: "isBat", label: "Batch", width: 70, type: "bool" },
        ]
    }));

    const newPaymentDialog = useDialog(close => <PaymentDialog close={close} useCustomerStore={props.useCustomerStore} onPaymentCreated={() => {
        usePaymentListStore.getState().fetch();
        props.useCustomerStore.getState().fetchServerData();
    }} />, "md");
    const accountStore = useAccountStore(p => ({ userTypeId: p.data?.accessTokenDecoded.userTypeId }));

    return <>
        {newPaymentDialog.render()}
        <DialogTitle>{customerDialogTitle("Payments", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            {renderListStore(usePaymentListStore, {
                header: listHeaderItems([
                    accountStore.userTypeId === UserTypeId.Admin && ["new", () => <Button title="New payment"
                        onClick={() => newPaymentDialog.show()}><Add /></Button>]
                ]),
            })}
        </DialogContent>
        <DialogActions>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
}
